/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 * The icons export
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.0.0
 */

import activeSubs from './image/active-20.svg';
import addIconWhite from './image/add-2.svg';
import archiveIcon from './image/archive-20.svg';
import arrowBack from './image/arrow-back-20-10.svg';
import arrowBackIcon from './image/arrow-back-40.svg';
import arrowDownSmallIcon from './image/arrow-down-20.svg';
import arrowDown from './image/arrow-down-32.svg';
import arrowDownSmallWhiteIcon from './image/arrow-down-white-20.svg';
import arrowDownWhite from './image/arrow-down-white-32.svg';
import arrowForward from './image/arrow-forward-20.svg';
import arrowLeftIcon from './image/arrow-left-32.svg';
import arrowLeftDisabledIcon from './image/arrow-left-disabled-32.svg';
import arrowLeftSuccessIcon from './image/arrow-left-success-32.svg';
import arrowLeftWhiteIcon from './image/arrow-left-white-32.svg';
import arrowListDownLinkSmall from './image/arrow-list-down-20-link.svg';
import arrowListDownSmall from './image/arrow-list-down-20.svg';
import arrowListDownMedium from './image/arrow-list-down-32.svg';
import arrowListLeftSmall from './image/arrow-list-left-20.svg';
import arrowListUpSmall from './image/arrow-list-up-16.svg';
import arrowRightIcon from './image/arrow-right-32.svg';
import arrowRightDisabledIcon from './image/arrow-right-disabled-24.svg';
import arrowRightInfoSmall from './image/arrow-right-info_small.svg';
import arrowRightWhiteIcon from './image/arrow-right-white-32.svg';
import arrowSortAsc from './image/arrow-sort-asc-20.svg';
import arrowSortDefault from './image/arrow-sort-default-20.svg';
import arrowSortDesc from './image/arrow-sort-desc-20.svg';
import arrowUp from './image/arrow-up-32.svg';
import arrowUpWhite from './image/arrow-up-white-32.svg';
import attachFileIcon from './image/attach-file-24.svg';
import attentionIcon from './image/attention-16.svg';
import attentionInvertIcon from './image/attention-invert-16.svg';
import attentionInvertBlackIcon from './image/attention-invert-black-16.svg';
import balanceSmallIcon from './image/balance-20.svg';
import balanceMediumIcon from './image/balance-32.svg';
import balanceGreyIcon from './image/balance-grey-16.svg';
import balanceWhiteIcon from './image/balance-white-20.svg';
import bellIcon from './image/bell.svg';
import blockIcon from './image/block-20.svg';
import blockSubs from './image/blocked-20.svg';
import browserWarning from './image/browser-warning.svg';
import calendarIcon from './image/calendar-20.svg';
import calendarDateIconBlue from './image/calendar-date-20-blue.svg';
import calendarDateIcon from './image/calendar-date-20.svg';
import callsGreenIcon from './image/calls-green-24.svg';
import callsSliderIcon from './image/calls-slider-20.svg';
import cancelBlueSmallIcon from './image/cancel-16-blue.svg';
import cancelSmallIcon from './image/cancel-16.svg';
import cancelErrorSmallIcon from './image/cancel-20-error.svg';
import cancelOpacitySmallIcon from './image/cancel-20-opacity.svg';
import cancelMiddleIcon from './image/cancel-20.svg';
import cancelIcon from './image/cancel-32.svg';
import cancelBlackIcon from './image/cancel-black-24.svg';
import cancelCircleGreenIcon from './image/cancel-circle-green.svg';
import cancelErrorIcon from './image/cancel-red-24.svg';
import chartIcon from './image/chart.svg';
import checkThinIcon from './image/check-thin.svg';
import checkedSuccessSmallIcon from './image/checked-20-success.svg';
import checkedIcon from './image/checked-20.svg';
import checkedIconBlack from './image/checked-black-16.svg';
import cockpitLogo from './image/cockpit-logo.svg';
import compareIcon from './image/compare-20.svg';
import compareSheetsIcon from './image/compare-sheets.svg';
import confetti from './image/confetti.png';
import corporateIcon from './image/corporate-20.svg';
import csvIcon from './image/csv.svg';
import defaultFileIcon from './image/default-file.svg';
import deleteDisabledIcon from './image/delete-16-disabled.svg';
import deleteIcon from './image/delete-16.svg';
import deleteDark from './image/delete-dark.svg';
import densityOff from './image/density-off.svg';
import densityOn from './image/density-on.svg';
import doneStatusIcon from './image/done-20.svg';
import downloadIcon from './image/download.svg';
import dragIcon from './image/drag.svg';
import editIconSmall from './image/edit-20.svg';
import editIconMedium from './image/edit-32.svg';
import editDisabledIcon from './image/edit-disabled.svg';
import editGreenIcon from './image/edit-green.svg';
import ellipseInfo from './image/ellipse-info.svg';
import errorStatusIcon from './image/error.svg';
import eyeOpened from './image/eye-open.svg';
import eyeClosed from './image/eye.svg';
import fileXlsIcon from './image/file-xls-icon.svg';
import fileXlsxIcon from './image/file-xlsx-icon.svg';
import filterIcon from './image/filter.svg';
import addIcon from './image/group-2.svg';
import groupIcon from './image/group.svg';
import halfSmallIcon from './image/half-20.svg';
import halfStatusIcon from './image/half.svg';
import htmlIcon from './image/html.svg';
import disabledIcon from './image/icon-disabled.svg';
import exitIcon from './image/icon-exit.svg';
import successIcon from './image/icon-success.svg';
import infinityIcon from './image/infinity-20.svg';
import infinityIconThick from './image/infinity-icon-thick-42.svg';
import infoErrorSmallIcon from './image/info-20-error.svg';
import infoPurpleIcon from './image/info-20-purple.svg';
import infoSuccessSmallIcon from './image/info-20-success.svg';
import infoWarningSmallIcon from './image/info-20-warning.svg';
import infoBlackSmallIcon from './image/info-black-20.svg';
import infoBlackIcon from './image/info-black-32.svg';
import infoGreyIcon from './image/info-invert-32.svg';
import infoBlueIcon from './image/info-invert-blue-20.svg';
import infoInvertErrorIcon from './image/info-invert-error-32.svg';
import infoLightBlueIcon from './image/info-light-blue-24.svg';
import infoDangerIcon from './image/info-red-32.svg';
import jpgIcon from './image/jpg.svg';
import launchIcon from './image/launch-24.svg';
import likeGreenIcon from './image/like-green-32.svg';
import linkIcon from './image/link-24.svg';
import loginIcon from './image/login-20.svg';
import mailGreenIcon from './image/mail-green-24.svg';
import messageIconSmall from './image/message-20.svg';
import messageIconMedium from './image/message-32.svg';
import moneyTransferIcon from './image/mnp-20.svg';
import mobileCashDeskIcon from './image/mobile-cash-desk-20.svg';
import filterNormalIcon from './image/normal.svg';
import noSim from './image/noSim.svg';
import paymentIconSmall from './image/o-payment-20.svg';
import paymentIconMedium from './image/o-payment-32.svg';
import payFriendSmall from './image/pay-friend-16.svg';
import pdfIcon from './image/pdf.svg';
import people from './image/people.svg';
import processStatusIcon from './image/process.svg';
import profileIconInfoSmall from './image/profile-16-info.svg';
import profileIconSmall from './image/profile-20.svg';
import profileIconMedium from './image/profile-32.svg';
import starIcon from './image/promo-20.svg';
import rangeSliderIcon from './image/range-slider.svg';
import refreshIcon from './image/refresh-20.svg';
import removeTinyOpacityIcon from './image/remove-16-opacity.svg';
import removeTinyIcon from './image/remove-16.svg';
import removeSmallOpacityIcon from './image/remove-20-opacity.svg';
import removeSmallIcon from './image/remove-20.svg';
import roamingGreenIcon from './image/roaming-green-24.svg';
import rtfIcon from './image/rtf.svg';
import sumIcon from './image/ruble-24.svg';
import saleIcon from './image/sale-20.svg';
import scrollbarThumbIcon from './image/scrollbar-thumb.png';
import searchSmallIcon from './image/search-20.svg';
import searchMediumIcon from './image/search-32.svg';
import searchGreenIcon from './image/search-green-24.svg';
import searchIndicator from './image/search-indicator.gif';
import settingIcon from './image/settings-20.svg';
import simCardSmallIcon from './image/sim-card-20.svg';
import simCardMediumIcon from './image/sim-card-32.svg';
import arrowSliderLeft from './image/sliderLeft.svg';
import arrowSliderLeftGrey from './image/sliderLeftGrey.svg';
import arrowSliderRight from './image/sliderRight.svg';
import arrowSliderRightGrey from './image/sliderRightGrey.svg';
import statisticsIcon from './image/statistics-20.svg';
import subscriberRuleProductIcon from './image/subscriber-rule-product.svg';
import subscriberRuleTariffIcon from './image/subscriber-rule-tariff.svg';
import supportIcon from './image/support-avatar-32.svg';
import syncBtnIcon from './image/sync-btn.svg';
import timeIconBlue from './image/time-icon-16-blue.svg';
import timeIconDanger from './image/time-icon-16-danger.svg';
import timeIconGrey from './image/time-icon-16-grey.svg';
import timeIconWarning from './image/time-icon-16-warning.svg';
import transactionSmallInfoIcon from './image/transaction-16-info.svg';
import transactionSmallIcon from './image/transaction-20.svg';
import transactionMediumIcon from './image/transaction-32.svg';
import txtIcon from './image/txt.svg';
import uploadIcon from './image/upload-20.svg';
import waiting from './image/waiting.svg';

export {
    activeSubs,
    addIcon,
    addIconWhite,
    archiveIcon,
    arrowBack,
    arrowBackIcon,
    arrowDown,
    arrowDownSmallIcon,
    arrowDownSmallWhiteIcon,
    arrowDownWhite,
    arrowForward,
    arrowLeftDisabledIcon,
    arrowLeftIcon,
    arrowLeftSuccessIcon,
    arrowLeftWhiteIcon,
    arrowListDownLinkSmall,
    arrowListDownMedium,
    arrowListDownSmall,
    arrowListLeftSmall,
    arrowListUpSmall,
    arrowRightDisabledIcon,
    arrowRightInfoSmall,
    arrowRightIcon,
    arrowRightWhiteIcon,
    arrowSliderLeft,
    arrowSliderLeftGrey,
    arrowSliderRight,
    arrowSliderRightGrey,
    arrowSortAsc,
    arrowSortDefault,
    arrowSortDesc,
    arrowUp,
    arrowUpWhite,
    attachFileIcon,
    attentionIcon,
    attentionInvertBlackIcon,
    attentionInvertIcon,
    balanceGreyIcon,
    balanceMediumIcon,
    balanceSmallIcon,
    balanceWhiteIcon,
    bellIcon,
    blockIcon,
    blockSubs,
    browserWarning,
    calendarDateIconBlue,
    calendarDateIcon,
    calendarIcon,
    callsGreenIcon,
    callsSliderIcon,
    cancelBlackIcon,
    cancelBlueSmallIcon,
    cancelCircleGreenIcon,
    cancelErrorIcon,
    cancelErrorSmallIcon,
    cancelIcon,
    cancelSmallIcon,
    cancelOpacitySmallIcon,
    cancelMiddleIcon,
    chartIcon,
    confetti,
    checkedIcon,
    checkThinIcon,
    checkedIconBlack,
    checkedSuccessSmallIcon,
    cockpitLogo,
    compareIcon,
    compareSheetsIcon,
    corporateIcon,
    csvIcon,
    deleteDisabledIcon,
    deleteIcon,
    deleteDark,
    defaultFileIcon,
    densityOff,
    densityOn,
    disabledIcon,
    doneStatusIcon,
    downloadIcon,
    dragIcon,
    editDisabledIcon,
    editGreenIcon,
    editIconMedium,
    editIconSmall,
    ellipseInfo,
    errorStatusIcon,
    exitIcon,
    eyeClosed,
    eyeOpened,
    fileXlsIcon,
    fileXlsxIcon,
    filterIcon,
    filterNormalIcon,
    groupIcon,
    halfSmallIcon,
    halfStatusIcon,
    htmlIcon,
    infinityIcon,
    infinityIconThick,
    infoBlackIcon,
    infoBlackSmallIcon,
    infoBlueIcon,
    infoDangerIcon,
    infoErrorSmallIcon,
    infoGreyIcon,
    infoInvertErrorIcon,
    infoLightBlueIcon,
    infoSuccessSmallIcon,
    infoWarningSmallIcon,
    infoPurpleIcon,
    jpgIcon,
    launchIcon,
    likeGreenIcon,
    linkIcon,
    loginIcon,
    mailGreenIcon,
    messageIconMedium,
    messageIconSmall,
    mobileCashDeskIcon,
    moneyTransferIcon,
    noSim,
    payFriendSmall,
    paymentIconMedium,
    paymentIconSmall,
    pdfIcon,
    people,
    processStatusIcon,
    profileIconInfoSmall,
    profileIconMedium,
    profileIconSmall,
    rangeSliderIcon,
    refreshIcon,
    removeSmallIcon,
    removeSmallOpacityIcon,
    removeTinyIcon,
    removeTinyOpacityIcon,
    roamingGreenIcon,
    rtfIcon,
    saleIcon,
    scrollbarThumbIcon,
    searchGreenIcon,
    searchIndicator,
    searchMediumIcon,
    searchSmallIcon,
    settingIcon,
    simCardMediumIcon,
    simCardSmallIcon,
    starIcon,
    statisticsIcon,
    subscriberRuleProductIcon,
    subscriberRuleTariffIcon,
    successIcon,
    sumIcon,
    supportIcon,
    syncBtnIcon,
    timeIconBlue,
    timeIconDanger,
    timeIconGrey,
    timeIconWarning,
    transactionMediumIcon,
    transactionSmallIcon,
    transactionSmallInfoIcon,
    txtIcon,
    uploadIcon,
    waiting,
};
